// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog-module--wrapper--2BNRD","leftColumn":"blog-module--leftColumn--2Cpe9","rightColumn":"blog-module--rightColumn--3TvOV","title":"blog-module--title--TP5l-"};